export function estados_brasil(){
  return [
    { "texto": "Selecione um estado", "valor": "" },
    { "texto": "Acre", "valor": "AC" },
    { "texto": "Alagoas", "valor": "AL" },
    { "texto": "Amapá", "valor": "AP" },
    { "texto": "Amazonas", "valor": "AM" },
    { "texto": "Bahia", "valor": "BA" },
    { "texto": "Ceará", "valor": "CE" },
    { "texto": "Distrito Federal", "valor": "DF" },
    { "texto": "Espírito Santo", "valor": "ES" },
    { "texto": "Goiás", "valor": "GO" },
    { "texto": "Maranhão", "valor": "MA" },
    { "texto": "Mato Grosso", "valor": "MT" },
    { "texto": "Mato Grosso do Sul", "valor": "MS" },
    { "texto": "Minas Gerais", "valor": "MG" },
    { "texto": "Pará", "valor": "PA" },
    { "texto": "Paraíba", "valor": "PB" },
    { "texto": "Paraná", "valor": "PR" },
    { "texto": "Pernambuco", "valor": "PE" },
    { "texto": "Piauí", "valor": "PI" },
    { "texto": "Rio de Janeiro", "valor": "RJ" },
    { "texto": "Rio Grande do Norte", "valor": "RN" },
    { "texto": "Rio Grande do Sul", "valor": "RS" },
    { "texto": "Rondônia", "valor": "RO" },
    { "texto": "Roraima", "valor": "RR" },
    { "texto": "Santa Catarina", "valor": "SC" },
    { "texto": "São Paulo", "valor": "SP" },
    { "texto": "Sergipe", "valor": "SE" },
    { "texto": "Tocantins", "valor": "TO" }
  ];
}

export function estado_civil(){
  return [
    { "texto": "Selecione seu estado civil", "valor": "" },
    { "texto": "Casado(a)", "valor": "Casado(a)" },
    { "texto": "Divorciado(a)", "valor": "Divorciado(a)" },
    { "texto": "Solteiro(a)", "valor": "Solteiro(a)" },
    { "texto": "Viúvo(a)", "valor": "Viúvo(a)" },
  ];
}